import $ from 'jquery';
import CurrencyConverter from 'shopify-currency-converter';
import Menu from '../components/Menu';
import ProductForm from './ProductForm';

export default class ProductMenu {
  constructor($el, data, postMessage, inQuickshop) {
    this.$el = $el;
    this.data = data;

    // Form
    this.form = new ProductForm(this.$el.find('[data-product-menu-form]'), {
      product: this.data.product,
      moneyFormat: this.data.money_format,
      postMessage: postMessage,
      useHistory: !inQuickshop,
      onSuccess: (response, quantity) => this._onAtcSuccess(response, quantity),
      onError: (response, error) => this._onAtcError(response, error),
      onVariantChange: (variant) => this._onVariantChange(variant),
      onQuantityChange: (variant, quantity) => this._onQuantityChange(variant, quantity),
    });

    // Select options button
    this.$productMenuButtonSelectOptionsVariantPrice =
      $('[data-product-menu-button-selectoptions-variant-price]', this.$el);

    // atc button
    this.$productMenuButtonAtcVariantPrice =
      $('[data-product-menu-button-atc-variant-price]', this.$el);

    // Success and failure elements
    this.$productAtcFailureMessage =
      $('[data-product-atc-failure-message]', this.$el);
    this.$productAtcSuccessMessage =
      $('[data-product-atc-success-message]', this.$el);
    this.$productAtcSuccessMessageVariantQuantity =
      $('[data-product-atc-success-message-variant-quantity]', this.$el);
    this.$productAtcSuccessMessageProductTitle =
      $('[data-product-atc-success-message-product-title]', this.$el);
    this.$productAtcSuccessMessageVariantOptions =
      $('[data-product-atc-success-message-variant-options]', this.$el);

    // Prime the variant data
    this._onVariantChange(this.form.variantHelper.getSelectedVariant());

    // Menu system states
    this.states = {
      defaultNoVariants: {
        buttonsSelector: '[data-product-menu-buttons-atc]',
        buttons: [
          {
            selector: '[data-product-menu-button-share]',
            callback: () => {
              this._clearFailure();
              this.menu.changeState(this.states.share);
            },
          },
          {
            selector: '[data-product-menu-button-atc]',
            callback: () => {
              this._clearFailure();
            },
          },
        ],
      },
      defaultWithVariants: {
        buttonsSelector: '[data-product-menu-buttons-selectoptions]',
        buttons: [
          {
            selector: '[data-product-menu-button-share]',
            callback: () => this.menu.changeState(this.states.share),
          },
          {
            selector: '[data-product-menu-button-selectoptions]',
            callback: () => this.menu.changeState(this.states.atc),
          },
        ],
      },
      share: {
        slideoutSelector: '[data-product-slideout-share]',
        buttonsSelector: '[data-product-menu-buttons-share]',
        buttons: [
          {
            selector: '[data-product-menu-button-cancel]',
            callback: () => this.menu.changeState(
              this.form.variantHelper.isDefault()
                ? this.states.defaultNoVariants
                : this.states.defaultWithVariants
            ),
          },
          {
            selector: '[data-product-menu-slideout-button-dismiss]',
            callback: () => this.menu.changeState(
              this.form.variantHelper.isDefault()
                ? this.states.defaultNoVariants
                : this.states.defaultWithVariants
            ),
          },
        ],
        dismiss: () => this.menu.changeState(
          this.form.variantHelper.isDefault()
            ? this.states.defaultNoVariants
            : this.states.defaultWithVariants
        ),
      },
      atc: {
        slideoutSelector: '[data-product-slideout-atc]',
        buttonsSelector: '[data-product-menu-buttons-atc]',
        buttons: [
          {
            selector: '[data-product-menu-button-share]',
            callback: () => {
              this._clearFailure();
              this.menu.changeState(this.states.share);
            },
          },
          {
            selector: '[data-product-menu-button-atc]',
            callback: () => {
              this._clearFailure();
            },
          },
          {
            selector: '[data-product-menu-slideout-button-dismiss]',
            callback: () => {
              this._clearFailure();
              this.menu.changeState(this.states.defaultWithVariants);
            },
          },
        ],
        dismiss: () => {
          this._clearFailure();
          this.menu.changeState(this.states.defaultWithVariants);
        },
      },
      atcFailure: {
        slideoutSelector: '[data-product-slideout-atc-failure]',
        buttonsSelector: '[data-product-menu-buttons-atc-failure]',
        buttons: [
          {
            selector: '[data-product-menu-button-cancel]',
            callback: () => this.menu.changeState(this.states.defaultNoVariants),
          },
          {
            selector: '[data-product-menu-slideout-button-dismiss]',
            callback: () => this.menu.changeState(this.states.defaultNoVariants),
          },
        ],
        dismiss: () => this.menu.changeState(this.states.defaultNoVariants),
      },
      atcSuccess: {
        slideoutSelector: '[data-product-slideout-atc-success]',
        buttonsSelector: '[data-product-menu-buttons-atc-success]',
        buttons: [
          {
            selector: '[data-product-menu-slideout-button-dismiss]',
            callback: () => this.menu.changeState(
              this.form.variantHelper.isDefault()
                ? this.states.defaultNoVariants
                : this.states.defaultWithVariants
            ),
          },
        ],
        dismiss: () => this.menu.changeState(
          this.form.variantHelper.isDefault()
            ? this.states.defaultNoVariants
            : this.states.defaultWithVariants
        ),
      },
    };

    // Product menu state manager
    const $productMenuContainer = $('[data-product-menu-container]', this.$el);
    this.menu = new Menu(
      $productMenuContainer,
      this.states,
      this.form.variantHelper.isDefault()
        ? this.states.defaultNoVariants
        : this.states.defaultWithVariants
    );
  }

  _clearFailure() {
    clearTimeout(this.errorMessageTimeout);
    this.$productAtcFailureMessage.hide(0);
  }

  _onVariantChange(variant) {
    // ATC
    this.$el.find('[data-product-menu-button-atc]')
      .prop('disabled', !variant.available);

    // ATC text
    this.$el.find('[data-product-menu-button-atc-text]')
      .text(variant.available
        ? this.data.text.product_available
        : this.data.text.product_unavailable
      );

    // Options
    this.form.variantHelper.$options
      .parent()
      .removeClass('option-soldout')
      .removeClass('option-selected')
      .addClass('option-disabled');

    this.form.variantHelper.$options.filter(':not(:disabled)')
      .parent()
      .removeClass('option-disabled');

    this.form.variantHelper.$options.filter('[data-soldout="true"]')
      .parent()
      .addClass('option-soldout');

    this.form.variantHelper.$options.filter(':checked')
      .parent()
      .addClass('option-selected');

    this._onQuantityChange(variant, this.form.quantity.value);
  }

  _onQuantityChange(variant, quantity) {
    const price = Shopify.formatMoney(variant.price * quantity, this.data.money_format);

    this.$productMenuButtonSelectOptionsVariantPrice
      .text(price)
      .each((index, el) => CurrencyConverter.update(el));

    this.$productMenuButtonAtcVariantPrice
      .text(price)
      .each((index, el) => CurrencyConverter.update(el));
  }

  _onAtcSuccess(response, quantity) {
    const productTitle = response.product_title;
    const options = response.variant_options.join(', ');

    this.$productAtcSuccessMessageVariantQuantity.text(quantity);
    this.$productAtcSuccessMessageProductTitle.text(productTitle);

    if (!this.form.variantHelper.isDefault()) {
      this.$productAtcSuccessMessageVariantOptions.text(options);
    }

    this.$productAtcFailureMessage.hide(0);
    this.menu.changeState(this.states.atcSuccess);
  }

  _onAtcError(response, error) {
    this.$productAtcFailureMessage.html(error);

    if (this.form.variantHelper.isDefault()) {
      this.menu.changeState(this.states.atcFailure);
      this.$productAtcFailureMessage.show(0);
    } else {
      this.$productAtcFailureMessage.fadeIn();
    }

    this.errorMessageTimeout = setTimeout(() => {
      if (this.form.variantHelper.isDefault()) {
        this.menu.changeState(this.states.defaultNoVariants);
        this.$productAtcFailureMessage.hide();
      } else {
        this.$productAtcFailureMessage.fadeOut();
      }
    }, 5000);
  }

  unload() {
    this.form.unload();
  }
}
